import moment from 'moment/moment'

export const getDateFormatted = value => value && moment(parseInt(value, 10) * 1000).format('YYYY-MM-DDTHH:mm') || ''

export const getMsDateFormatted = value => value && moment(parseInt(value, 10)).format('YYYY-MM-DDTHH:mm') || ''

export const formatDate = value => value && moment(value).format('YYYY-MM-DDTHH:mm') || ''

export const formatDateWithoutTime = value => value && moment(value).format('YYYY-MM-DD') || ''
